import * as React from "react";
import type { SVGProps } from "react";
const SvgParcelBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="m16.99 6.13-.009-.034a.21.21 0 0 0-.09-.119l-.002-.001-6.776-3.945a.22.22 0 0 0-.227 0L3.111 5.976l-.002.001a.22.22 0 0 0-.09.119l-.01.036c0 .011-.009.023-.009.036v7.754c0 .08.043.153.112.193l6.764 3.856q.054.03.112.029.007-.001.012-.004c.005 0 .008.004.012.004q.058 0 .112-.03l6.763-3.855A.22.22 0 0 0 17 13.92V6.169c0-.013-.008-.025-.01-.037M10 2.483l6.329 3.684-1.876 1.069-6.41-3.614zm0 7.29L3.671 6.166l1.825-1.061 6.295 3.648zM7.597 3.88l6.405 3.612-1.763 1.004-6.3-3.65zm4.866 5.003 1.768-1.007V9.43l-1.768.94zm-2.699 8.51-3.62-2.065v-2.396c0-.123-.101-.223-.225-.223-.123 0-.224.1-.224.223v2.14l-.986-.562c0-.006.006-.01.006-.015v-2.413c0-.123-.1-.223-.224-.223s-.224.1-.224.223v2.175l-.819-.465v-7.24l6.316 3.6zm6.788-3.6-6.316 3.6v-7.24l1.778-1.015v1.604a.22.22 0 0 0 .224.223.2.2 0 0 0 .106-.027L14.56 9.76a.22.22 0 0 0 .118-.196V7.62l1.874-1.068z" />
  </svg>
);
export default SvgParcelBox;
